import { Beneficiary } from '@/store/beneficiary'
import { BeneficiaryDTO } from '@repo/shared/dtos/beneficiary'
import { generateId } from '@repo/shared/uuid/uuid'
import { Factory } from 'fishery'

type BeneficiaryStructuredDataParams = {
  fullName: string
  gender: string
  numberOfChildren: number
  isMarried: boolean
  dateOfBirth: string
}

class BeneficiaryDTOFactory extends Factory<BeneficiaryDTO> {
  with_structured_data(params: Partial<BeneficiaryStructuredDataParams> = {}) {
    return this.params({
      fullName: params.fullName || 'Rosa',
      structuredData: {
        value: [
          { schemaItemId: 'field-1', value: params.fullName || 'Rosa' },
          { schemaItemId: 'field-2', value: params.gender || 'Female' },
          { schemaItemId: 'field-3', value: params.numberOfChildren ?? 2 },
          { schemaItemId: 'field-4', value: params.isMarried ?? true },
          {
            schemaItemId: 'field-5',
            value: new Date(params.dateOfBirth ?? '1990-01-01').getTime(),
          },
        ],
        traceUrl: 'https://www.langfuse.com/123456',
      },
    })
  }
}

export const beneficiaryDTOFactory = BeneficiaryDTOFactory.define(() => {
  return {
    id: generateId(),
    status: 'enabled',
    fullName: 'Rosa',
    profile: {
      value: 'Lorem ipsum dolor sit amet',
      traceUrl: 'https://www.langfuse.com/abcdef',
    },
    structuredData: {
      value: [],
      traceUrl: undefined,
    },
    caseWorkerIds: [],
    createdAt: new Date().getTime(),
    updatedAt: new Date().getTime(),
  } satisfies Beneficiary
})

export const buildBeneficiaryDTOList = () => {
  return [
    beneficiaryDTOFactory.with_structured_data(),
    beneficiaryDTOFactory.with_structured_data({
      fullName: 'James Bond',
      gender: 'Male',
      numberOfChildren: 0,
      isMarried: true,
      dateOfBirth: '1982-10-05',
    }),
    beneficiaryDTOFactory.with_structured_data({
      fullName: 'Lara Croft',
      gender: 'Female',
      numberOfChildren: 1,
      isMarried: false,
      dateOfBirth: '1988-07-05',
    }),
    beneficiaryDTOFactory.with_structured_data({
      fullName: 'Harry Potter',
      gender: 'Male',
      numberOfChildren: 0,
      isMarried: false,
      dateOfBirth: '1980-07-31',
    }),
    beneficiaryDTOFactory.with_structured_data({
      fullName: 'Bill Baroud',
      gender: 'Male',
      numberOfChildren: 3,
      isMarried: true,
      dateOfBirth: '1975-03-15',
    }),
  ].map((factory) => factory.build({}))
}
